var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.109 5.33012H19.7509C20.7168 5.33012 21.5 6.12968 21.5 7.11976V7.85405C21.0159 7.47037 20.4092 7.24123 19.7509 7.24123H4.24908C3.59076 7.24123 2.98409 7.47041 2.5 7.85405V5.28964C2.5 4.30286 3.28464 3.5 4.24911 3.5H7.33253C7.7997 3.5 8.23896 3.68616 8.56931 4.02417L9.65947 5.13959C9.77956 5.26246 9.9392 5.33012 10.109 5.33012ZM4.24908 8.38024H19.7509C20.7168 8.38024 21.5 9.1798 21.5 10.1698V18.7104C21.5 19.6987 20.7185 20.5 19.7509 20.5H4.24908C3.28304 20.5 2.5 19.7003 2.5 18.7104V10.1698C2.5 9.18139 3.2816 8.38024 4.24908 8.38024Z",
    fill: "#E550FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.4bd7e954.svg";
export { ForwardRef as ReactComponent };